/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxJobsPerRunnerSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_JOBS_PER_RUNNER')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AutoTestMaxJobsPerRunnerSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxJobsPerRunnerSettingParser.decode(input).map(res => new AutoTestMaxJobsPerRunnerSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxJobsPerRunnerSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxJobsPerRunnerSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxJobsPerRunnerSettingParser.schema();
    }
}
